// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"dac5cc4c","732":"ba58e312","977":"8dd7c1b2"}[chunkId] + ".chunk.js";
};